<h5 class="title mb-4 text-primary text">{{'fim'|translate}}</h5>

<div *ngIf="!authService.isAuthenticated()">
    <p *ngIf="mdcService.selectedMethod !== 'qrcode' && mdcService.selectedMethod !== 'captcha'">
        {{'verificacao_6_dgt_title'|translate}}</p>
    <div class="row g-3">
        <div class="col-12" *ngIf="mdcService.selectedMethod == 'qrcode'">
            <div class="d-flex align-items-start">
                <div class="pe-5">
                    <h6>{{'verificacao_qr_code'|translate}}</h6>
                    <p class="small">{{'verificacao_read_qr_code'|translate}}</p>
                </div>                
                <div class="border p-0 round-lg w-350px bg-white bg-dark">
                    <ng-container *ngIf="mdcService.qrCodeImage; else loading_qrcode">
                        <img [src]="mdcService.qrCodeImage" alt="qr-code" (error)="onImageError($event)">                        
                      </ng-container>
                      <ng-template #loading_qrcode>
                        <div class="p-3 text-center text-muted">Carregando imagem...</div>
                      </ng-template>
                   
                </div>
            </div>
        </div>
        <div class="col-12" *ngIf="mdcService.selectedMethod == 'captcha'">
            <div class="d-flex align-items-center">
                <div class="border p-0 round-lg bg-white bg-dark">
                    <ng-container *ngIf="mdcService.captchaImageUrl; else loading_captcha">
                      <img 
                        [src]="mdcService.captchaImageUrl" 
                        alt="captcha"
                        (error)="onImageError($event)"
                      >
                    </ng-container>
                    <ng-template #loading_captcha>
                      <div class="p-3 text-center text-muted">Carregando imagem...</div>
                    </ng-template>
                  </div>
                <a style="cursor:pointer" (click)="mdcService.recaptcha()"
                    class="ms-2 btn btn-icon btn btn-dim btn-sm btn-outline-primary"><em
                        class="icon ni ni-reload-alt"></em></a>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">

                <label class="form-label"
                    *ngIf="mdcService.selectedMethod !== 'qrcode' && mdcService.selectedMethod !== 'captcha'"
                    for="cp-code">{{'verificacao_6_dgt_send_to'|translate}}
                    {{mdcService.formCodeData.phonenumberoremail}}</label>

                <label class="form-label"
                    *ngIf="mdcService.selectedMethod == 'qrcode' || mdcService.selectedMethod == 'captcha'"
                    for="cp-code">{{'verificacao_code'|translate}}</label>

                <div class="form-control-wrap">

                    <input [(ngModel)]="mdcService.formCodeData.code" type="number" class="form-control" id="cp-code"
                        name="cp-code" placeholder="000000" maxlength="6" minlength="6" required
                        [attr.data-msg]="('obrigatorio_error_msg' | translate)"
                        *ngIf="mdcService.selectedMethod !== 'captcha'">

                    <input [(ngModel)]="mdcService.formCodeData.code" type="text" class="form-control" id="cp-code"
                        name="cp-code" required [attr.data-msg]="('obrigatorio_error_msg' | translate)"
                        *ngIf="mdcService.selectedMethod == 'captcha'">

                </div>

                <div class="my-2"
                    *ngIf="mdcService.selectedMethod !== 'qrcode' && mdcService.selectedMethod !== 'captcha'">
                    <p class="small">
                        {{'verificacao_6_dgt_resend'|translate}}
                        <a style="cursor:pointer" (click)="mdcService.resendCode()"
                            [class.disabled]="mdcService.isDisabledResendCode"
                            [attr.disabled]="mdcService.isDisabledResendCode ? true : null">{{'verificacao_6_dgt_resend_click'|translate}}</a>
                        <span *ngIf="mdcService.isDisabledResendCode">({{mdcService.counterResendCode}}s)</span>
                    </p>
                </div>

                <div class="form-note">{{'fim_msg'|translate}}</div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="authService.isAuthenticated()">
    <p class="text-soft">{{'fim_msg'|translate}}</p>
    <div class="gfx w-50 mx-auto">
        <app-successful-icon></app-successful-icon>
    </div>
</div>